import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';

import validationSchema from 'src/utils/validationSchema';

import { useTranslate } from 'src/locales';
import { AuthLoader } from 'src/pages/auth/component/auth-loader';
import { useGetAssigneeList } from 'src/pages/tickets/hooks/useGetAssigneeList';
import { CustomAutocomplete } from 'src/pages/tickets/components/custom-autocomplete';

import { Form } from 'src/components/hook-form';

import { useChannelContext } from '../hooks';

export function Step3() {
  const { onChangeStep, state: channelState, isLoading, setField } = useChannelContext();
  const { t } = useTranslate('translation');

  const {
    _recordList,
    searchValue,
    open,
    isFetching,
    listScrollHandler,
    searchValueHandler,
    openListHandler,
    closeListHandler,
  } = useGetAssigneeList({});

  type CampaignField = { category: string };
  const fldList = [{ name: 'category', required: false }];
  const CampaignSchema = validationSchema(fldList, t);

  const methods = useForm<CampaignField>({
    mode: 'all',
    resolver: zodResolver(CampaignSchema),
    defaultValues: { category: '' },
    values: { category: channelState.assignedId.label ?? '' },
  });

  const { reset, handleSubmit } = methods;

  // Handlers
  const onSubmit = handleSubmit(() => {
    reset();
  });

  const handleChange = ({ value, fieldName }: { value: any; fieldName: string }) => {
    setField('assignedId', value);
    setField('assignedType', value.isUser ? 'User' : 'Team');
  };

  return (
    <Form methods={methods} onSubmit={onSubmit} style={{ height: '100%' }}>
      <Box sx={{ height: '90%', display: 'flex', flexDirection: 'column' }}>
        {isLoading && <AuthLoader />}

        <Grid container spacing={3} justifyContent="space-between">
          <CustomAutocomplete
            name="assignedId"
            label="Assigned To"
            isOptionEqualToValue={(a, b) => a.id === b.id}
            placeholder="Select a Team"
            options={_recordList}
            searchValue={searchValue}
            listScrollHandler={listScrollHandler}
            searchValueHandler={searchValueHandler}
            open={open}
            openListHandler={openListHandler}
            closeListHandler={closeListHandler}
            isFetching={isFetching}
            onChangeField={handleChange}
          />
        </Grid>

        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Box>
            <Button variant="outlined" color="inherit" onClick={() => onChangeStep('back')}>
              {t('PREVIOUS')}
            </Button>
          </Box>
          <Box>
            <Button
              fullWidth
              size="small"
              type="submit"
              variant="contained"
              // disabled={!categoryName}
              onClick={() => onChangeStep('next')}
            >
              {t('NEXT')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  );
}
